<!--suppress ALL -->
<template>
  <!--<bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
        <component  :is="currentTab" :currentTab='currentTab'></component>
  </bsp-tabs>-->
  <div class="outer-layer">
    <el-tabs
      v-model="activeName"
      @tab-click="changeTab"
    >
      <el-tab-pane
        v-for="(item,i) in msgTypes"
        :name="item.type"
        lazy="true"
      >
        <span slot="label">{{ item.typeName }}<span
          class="un-read"
          v-if="item.num>0"
        >{{ item.num }}</span></span>
        <component
          is="msgList"
          :current-tab="item.type" v-if="item.source==='wage'"
        />
        <component
          is="msgHrcloudList"
          :current-tab="item.type" v-if="item.source==='hrcloud'"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
  import msgList from "./msgList.vue";
  import msgHrcloudList from "./msgHrcloudList.vue";
  import {getUnReadMsgNum} from "@/api/msg/msg";

  export default {
    data() {
      return {
        role: {
          tenantId: 'sys',
          name: 'admin'
        },
        activeName:"30420009",
        msgTypes: [
          {type: "30420009", typeName: "系统消息", num: 0, source: "hrcloud"},
          {type: "1", typeName: "薪酬消息", num: 0, source: "wage"},
          {type: "30420007", typeName: "休假消息", num: 0, source: "hrcloud"},
          {type: "30420008", typeName: "考勤消息", num: 0, source: "hrcloud"},
          {type: "30420005", typeName: "其他消息", num: 0, source: "hrcloud"},
        ]
      }
    },
    components: {
      msgList,msgHrcloudList
    },
    created() {
      for(let i=0;i<this.msgTypes.length;i++){
        this.queryUnReadMsgNum(i);
      }
    },
    methods: {
      changeTab(tab, event) {
        this.currentTab = tab.name;
      },
      //加载未读消息数量
      queryUnReadMsgNum(i) {
        if (this.msgTypes[i].source === 'hrcloud') {
          getUnReadMsgNum(this.msgTypes[i].type).then(res => {
            this.msgTypes[i].num = res.data.data;
          });
        } else {
          //消息服务
        }
      }
    }
  }
</script>
<style>
  .un-read {
    color: #fff;
    background: #ff0000;
    border-radius: 10px;
    padding: 1px 4px;
    font-size: 12px;
  }
</style>
